import React from "react";
import { useTranslation } from "react-i18next";

const SAGE = "#4A6157";

const PackageIcon = ({ size = 17, color = SAGE }) => (
	<svg width={size} height={size} viewBox="0 0 24 24" fill="none" style={{ flexShrink: 0 }}>
		<path d="M3.5 7.5L12 3.5l8.5 4v9L12 20.5l-8.5-4v-9z" stroke={color} strokeWidth="1.8" strokeLinejoin="round" />
		<path d="M3.5 7.5L12 11.6l8.5-4.1M12 11.6v8.9" stroke={color} strokeWidth="1.8" strokeLinejoin="round" />
	</svg>
);

const CheckoutSessionPackageContainer = ({ sessionsAccepted, onSwitch, isPending = false }) => {
	const { t } = useTranslation();

	if (!sessionsAccepted || sessionsAccepted.length === 0) return null;

	const session = sessionsAccepted[0];
	const packageName = session?.infoPackage?.packageName || "";
	const remaining = session?.infoPackage?.packageRemainding ?? "";
	const total = session?.infoPackage?.packageQuantity ?? "";
	const expiry = session?.infoPackage?.packageExpiry || null;

	const remainingText = remaining !== "" && total !== ""
		? t("package_line_remaining", { remaining, total })
		: "";
	const expiryText = expiry ? t("package_line_valid_until", { date: expiry }) : "";
	const infoLine = [remainingText, expiryText].filter(Boolean).join(" · ");

	return (
		<div style={{ marginBottom: 12 }}>
			<div style={{
				background: "#fff",
				border: "1px solid #DDD8CE",
				borderRadius: 12,
				padding: "12px 13px",
				display: "flex",
				alignItems: "flex-start",
				gap: 10,
			}}>
				<div style={{ marginTop: 2 }}>
					<PackageIcon size={17} />
				</div>
				<div style={{ flex: 1, minWidth: 0 }}>
					<div style={{ fontSize: 13.5, fontWeight: 700, color: SAGE, lineHeight: 1.3 }}>
						{t("checkout_session_container_paid")}
					</div>
					{packageName ? (
						<div style={{ fontSize: 12.5, color: SAGE, marginTop: 2, lineHeight: 1.35 }}>
							{packageName}
						</div>
					) : null}
					{infoLine ? (
						<div style={{ fontSize: 12.5, color: SAGE, marginTop: 2 }}>
							{infoLine}
						</div>
					) : null}
				</div>
				<button
					onClick={onSwitch}
					style={{
						background: "transparent",
						border: "none",
						cursor: "pointer",
						fontSize: 13,
						fontWeight: 700,
						color: SAGE,
						flexShrink: 0,
						padding: 0,
						fontFamily: "inherit",
						marginTop: 1,
					}}>
					{t("checkout_session_switch")}
				</button>
			</div>
		</div>
	);
};

export default CheckoutSessionPackageContainer;
